<template>
  <div class="page">
    <box>
      <el-form label-position="right" label-width="90px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="工厂编号" class="EL-Form-Item">
            <el-select
              multiple
              collapse-tags
              v-model="selectedFcList"
              filterable
              clearable="clearable"
            >
              <el-option
                v-for="item in factoryList"
                :key="item.fcCode"
                :value="item.fcCode"
                :label="item.fcCode"
                >{{ item.fcCode }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="通道编号" class="EL-Form-Item">
            <el-select
              multiple
              collapse-tags
              v-model="whCodeList"
              filterable
              placeholder="请选择"
              clearable="clearable"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.whId"
                :value="item.whCode"
                :label="item.whCode + '-' + item.whName"
                >{{ item.whCode }}-{{ item.whName }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.matCode"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料描述" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.matName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="saveSearch()">查询</el-button>
            <el-button class="btn-t-delete" @click="reset">重置</el-button>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
          <el-form-item label="物料批次" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.batchNo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5" v-if="!mainSearch.fcCode">
          <el-form-item label="物料批次" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.batchNo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料状态" class="EL-Form-Item">
            <el-select v-model="mainSearch.wiStatus" clearable="clearable">
              <el-option key="0" value="" label="全部"></el-option>
              <el-option label="正常" value="NORMAL"> </el-option>
              <el-option label="拣配中" value="FREEZE"> </el-option>
              <!-- <el-option label="过期" value="OVERTIME"> </el-option>
                            <el-option label="作废" value="DELETE"> </el-option> -->
              <el-option label="冻结" value="AGFREEZE"> </el-option>
              <el-option label="不合格" value="UNQUALIFIED"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="库位" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.lcCode"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="第几层" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.height"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="包装箱号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.boxBarcode"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="订单编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.orderCode"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker
              v-model="mainSearch.date[0]"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="开始日期"
              :picker-options="pickerOptions0"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="结束日期" class="EL-Form-Item">
            <el-date-picker
              v-model="mainSearch.date[1]"
              value-format="yyyy-MM-dd HH:mm"
              type="date"
              placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form>
    </box>
    <box fill>
      <plabel text="库存列表">
        <el-button v-authority="'BACK_MENU3_M2_B1'" @click="addWhInventory()" class="btn-t-edit">库存新增</el-button>
        <el-button
          v-authority="'BACK_MENU3_M2_B1'"
          @click="upWhInventory()"
          class="btn-t-edit"
          >库存编辑</el-button
        >
        <el-button
          v-authority="'BACK_MENU3_M2_B2'"
          @click="pdfPrint()"
          class="btn-t-edit"
          >单据打印</el-button
        >
        <el-button
          v-authority="'BACK_MENU3_M2_B3'"
          @click="rePrintBarcode()"
          class="btn-t-edit"
          >标签打印</el-button
        >
        <el-button
          v-authority="'BACK_MENU3_M2_B3'"
          @click="getNewBoxBarcode()"
          class="btn-t-edit"
          >标签补打</el-button
        >
        <el-button v-authority="'BACK_MENU3_M2_B5'" @click="openInventorySummaryDialog()" class="btn-t-edit">库存汇总</el-button>
        <el-button
          v-authority="'BACK_MENU3_M2_B4'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
          >导出EXCEL</el-button
        >
      </plabel>
      <h-table
        :summary-method="getSummaries"
        show-summary
        :headerCellStyle="mainData.headerCellStyle"
        style="flex: 1"
        @pageChange="getTableData()"
        :data="mainData.data"
        pagination
        :nowPage.sync="mainData.nowPage"
        :pageSize.sync="mainData.pageSize"
        :total.sync="mainData.total"
        ref="hTable"
        @selectionChange="selectAllPrintLists"
      >
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column
          label="工厂编号"
          align="center"
          prop="fcCode"
        ></el-table-column>
        <el-table-column
          label="通道编号"
          align="center"
          prop="whCode"
        ></el-table-column>
        <el-table-column
          label="物料编号"
          align="center"
          prop="matCode"
        ></el-table-column>
        <el-table-column
          label="物料描述"
          align="center"
          prop="matName"
        ></el-table-column>
        <el-table-column
          label="物料总数量"
          align="center"
          prop="matQuan"
        ></el-table-column>
        <el-table-column
          label="已分配数量"
          align="center"
          prop="matDistrQuan"
        ></el-table-column>
        <el-table-column
          label="可用数量"
          align="center"
          prop="matAvaliableQuan"
        >
          <template slot-scope="scope">
            {{ scope.row.matQuan - scope.row.matDistrQuan }}
          </template>
        </el-table-column>
        <el-table-column
          label="物料批次"
          align="center"
          prop="batchNo"
        ></el-table-column>
        <el-table-column
          label="库位"
          align="center"
          prop="lcCode"
        ></el-table-column>
        <el-table-column
          label="包装箱号"
          align="center"
          prop="boxBarcode"
        ></el-table-column>
        <el-table-column
          label="订单编号"
          align="center"
          prop="orderCode"
        ></el-table-column>
        <el-table-column label="物料状态" align="center" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
            <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
            
            <!-- <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span> -->
            <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
            <span v-if="scope.row.wiStatus == 'UNQUALIFIED'">不合格</span>
          </template>
        </el-table-column>
        <el-table-column
          label="收货人"
          align="center"
          prop="consignee"
        ></el-table-column>
        <el-table-column
          label="入库时间"
          align="center"
          prop="matCreateTime"
          :formatter="dateFormat"
        ></el-table-column>
        <el-table-column label="质检状态" align="center" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.checkResult == '10'">待检</span>
            <span v-if="scope.row.checkResult == '20'">合格</span>
            <span v-if="scope.row.checkResult == '30'">不合格</span>
          </template>
        </el-table-column>
        <el-table-column label="是否寄售" align="center" width="120px">
          <template slot-scope="scope">
            {{ scope.row.saleFlag ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          label="供应商"
          align="center"
          width="120px"
          prop="verdorCode"
        >
        </el-table-column>
        <el-table-column
          label="供应商名称"
          align="center"
          width="120px"
          prop="svName"
        >
        </el-table-column>
        <el-table-column
          label="备注"
          align="center"
          prop="remark"
        ></el-table-column>
        <el-table-column
          label="炉号"
          align="center"
          prop="heatNumber"
        ></el-table-column>
      </h-table>
    </box>

    <!-- 打印 -->
    <el-dialog
      title="打印"
      :visible.sync="printShow"
      width="1000px"
      :close-on-click-modal="false"
      style="height: 100%"
    >
      <div class="divdiv">
        <v-print :doPrint.sync="print">
          <div id="demo" class="demo11">
            <div style="margin-top: 20px; margin-left: 800px">
              <el-button
                class="btn-t-info"
                type="info"
                @click="
                  (printShow = false),
                    ((printList = []), (boxCount = 0), (sumCount = 0))
                "
                >取消</el-button
              >
              <el-button
                class="btn-t-edit"
                @click="
                  ((print = true), (printShow = false)),
                    ((boxCount = 0), (sumCount = 0))
                "
                >打印</el-button
              >
            </div>
            <div class="div1">
              打印时间：{{ printTime }}&nbsp;&nbsp;&nbsp;&nbsp;箱数：{{
                boxCount
              }}&nbsp;&nbsp;&nbsp;&nbsp;总数量：{{ sumCount }}
            </div>
            <div class="div">
              <table border="1" cellpadding="0" cellspacing="0">
                <thead style="display: table-header-group; font-weight: bold">
                  <tr>
                    <th>通道编号</th>
                    <th>物料编号</th>
                    <th>物料描述</th>
                    <th>物料数量</th>
                    <th>物料批次</th>
                    <th>库位</th>
                    <th>包装箱号</th>
                    <th>规值</th>
                    <th>物料状态</th>
                    <th>入库时间</th>
                    <th>备注</th>
                  </tr>
                </thead>
                <tr v-for="(item, index) in printData" :key="index">
                  <td>{{ item.whCode }}</td>
                  <td>{{ item.matCode }}</td>
                  <td>{{ item.matName }}</td>
                  <td>{{ item.matQuan }}</td>
                  <td>{{ item.batchNo }}</td>
                  <td>{{ item.lcCode }}</td>
                  <td>{{ item.boxBarcode }}</td>
                  <td>{{ item.matSpecs }}</td>
                  <td>
                    <span v-if="item.wiStatus == 'NORMAL'">正常</span>
                    <span v-if="item.wiStatus == 'FREEZE'">拣配中</span>
                    <!-- <span v-if="item.wiStatus == 'OVERTIME'">过期</span>
                                        <span v-if="item.wiStatus == 'DELETE'">作废</span> -->
                    <span v-if="item.wiStatus == 'AGFREEZE'">冻结</span>
                  </td>
                  <td>{{ item.matCreateTime }}</td>
                  <td>{{ item.remark }}</td>
                </tr>
              </table>
            </div>
          </div>
        </v-print>
      </div>
      <div style="margin-top: 50px; height: 70px">
        <!-- <el-button class="btn-t-edit" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button> -->
      </div>
    </el-dialog>

    <!-- 库存新增 -->
    <el-dialog title="库存新增" :visible.sync="addDataShow" class="infoDialog" :close-on-click-modal="false" :show-close="false">
      <el-form label-position="right" label-width="90px" class="EL-Form" :rules="ruleUp" :model="addDataObj" ref="addDataObj">
        <el-col :lg="8" :xl="8">
          <el-form-item label="通道编号" class="EL-Form-Item" prop="whCode">
            <el-input v-model="addDataObj.whCode" placeholder="请输入" clearable="clearable" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="物料编号" class="EL-Form-Item" prop="matCode">
            <el-input v-model="addDataObj.matCode" placeholder="请输入" clearable="clearable" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="物料总数量" class="EL-Form-Item" prop="matQuan">
            <el-input-number v-model="addDataObj.matQuan" :min="0" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="批次号" class="EL-Form-Item" prop="matCode">
            <el-input v-model="addDataObj.batchNo" placeholder="请输入" clearable="clearable" />
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDataShow = false;this.addDataObj.matCode = null;this.addDataObj.matQuan = 0;" type="info">取 消</el-button>
        <el-button @click="saveWhInventory()" type="danger">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 库存编辑 -->
    <el-dialog
      title="库存编辑"
      :visible.sync="upDataShow"
      class="infoDialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form
        label-position="right"
        label-width="90px"
        class="EL-Form"
        :rules="ruleUp"
        :model="upDataObj"
        ref="upDataObj"
      >
        <el-col :lg="8" :xl="8">
          <el-form-item label="通道编号" class="EL-Form-Item" prop="whCode">
            <el-input
              v-model="upDataObj.whCode"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="库位" class="EL-Form-Item" prop="lcCode">
            <el-input
              v-model="upDataObj.lcCode"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="物料编号" class="EL-Form-Item" prop="matCode">
            <el-input
              v-model="upDataObj.matCode"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="物料批次" class="EL-Form-Item" prop="batchNo">
            <el-input
              v-model="upDataObj.batchNo"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="物料总数量" class="EL-Form-Item" prop="matQuan">
            <el-input-number
              v-model="upDataObj.matQuan"
              :min="0"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="入库时间" class="EL-Form-Item">
            <el-input
              v-model="upDataObj.matCreateTime"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="物料描述" class="EL-Form-Item">
            <el-input v-model="upDataObj.matName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="已分配数量" class="EL-Form-Item">
            <el-input v-model="upDataObj.matDistrQuan"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="箱号" class="EL-Form-Item">
            <el-input v-model="upDataObj.boxBarcode" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="订单号" class="EL-Form-Item">
            <el-input v-model="upDataObj.orderCode" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="规值" class="EL-Form-Item">
            <el-input v-model="upDataObj.matSpecs" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="物料状态" class="EL-Form-Item">
            <el-select v-model="upDataObj.wiStatus" disabled>
              <el-option key="0" value="" label="全部"></el-option>
              <el-option label="正常" value="NORMAL"> </el-option>
              <el-option label="拣配中" value="FREEZE"> </el-option>
              <el-option label="过期" value="OVERTIME"> </el-option>
              <el-option label="作废" value="DELETE"> </el-option>
              <el-option label="人工冻结" value="AGFREEZE"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="收货人" class="EL-Form-Item">
            <el-input v-model="upDataObj.consignee" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="质检状态" class="EL-Form-Item">
            <el-select v-model="upDataObj.checkResult">
              <el-option label="待检" value="10"> </el-option>
              <el-option label="合格" value="20"> </el-option>
              <el-option label="不合格" value="30"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upDataShow = false" type="info">取 消</el-button>
        <el-button @click="updateWhInventory()" type="danger">编辑</el-button>
      </div>
    </el-dialog>

    <!-- 标签补打 -->
    <el-dialog
      title="标签补打"
      :visible.sync="PrintBarcodeByDia"
      class="infoDialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form
        label-position="right"
        label-width="90px"
        class="EL-Form"
        :rules="ruleUp"
        :model="PrintBarcodeByObj"
        ref="PrintBarcodeByObj"
      >
      
        <el-col :lg="8" :xl="8">
          <el-form-item label="箱号" class="EL-Form-Item" prop="boxBarcode">
            <el-input
              v-model="PrintBarcodeByObj.boxBarcode"
              clearable="clearable"
              readonly="readonly"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="物料编号" class="EL-Form-Item" prop="prodCode">
            <el-select v-model="PrintBarcodeByObj.prodCode" placeholder="请选择" filterable clearable="clearable">
                                <el-option v-for="(item, index) in materialData" :key="index" :label="item.mtName" :value="item.mtCode">
                                </el-option>
                            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="物料描述" class="EL-Form-Item" prop="prodName">
            <el-input
              v-model="PrintBarcodeByObj.prodName"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :lg="8" :xl="8">
          <el-form-item label="规值" class="EL-Form-Item" prop="matSpecs">
            <el-input
              v-model="PrintBarcodeByObj.matSpecs"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col> -->
                <!-- <el-col :lg="8" :xl="8">
          <el-form-item label="箱数" class="EL-Form-Item" prop="printTwo">
            <el-input-number
              v-model="PrintBarcodeByObj.printTwo"
              placeholder="请输入"
              :min="0"
              clearable="clearable"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </el-col> -->
        <el-col :lg="8" :xl="8">
          <el-form-item label="通道" class="EL-Form-Item" prop="whCode">
            <el-input
              v-model="PrintBarcodeByObj.whCode"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="批次号" class="EL-Form-Item" prop="batchNo">
            <el-input
              v-model="PrintBarcodeByObj.batchNo"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :xl="8">
          <el-form-item label="数量" class="EL-Form-Item" prop="count">
            <el-input-number
              v-model="PrintBarcodeByObj.count"
              :min="0"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </el-col>

        <!-- <el-col :lg="8" :xl="8">
          <el-form-item label="供应商" class="EL-Form-Item" prop="supply">
            <el-input
              v-model="PrintBarcodeByObj.supply"
              style="width: 100%"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col> -->
<!-- 
        <el-col :lg="8" :xl="8">
          <el-form-item label="库位" class="EL-Form-Item" prop="location">
            <el-input
              v-model="PrintBarcodeByObj.location"
              style="width: 100%"
              placeholder="请输入"
              clearable="clearable"
            ></el-input>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :lg="8" :xl="8">
          <el-form-item label="入库时间" class="EL-Form-Item" prop="date">
            <el-date-picker
              v-model="PrintBarcodeByObj.date"
              type="datetime"
              placeholder="选择日期时间"
              default-time="12:00:00"
            >
            </el-date-picker>
          </el-form-item>
        </el-col> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="PrintBarcodeByDia = false" type="info"
          >取 消</el-button
        >
        <el-button @click="PrintBarcodeBy()" type="danger">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 库存汇总 -->
    <!-- :close="closeProductPullDialog" -->
    <el-dialog class="fromDialog" :style="$popups.popups(0.6,0.9)" title="库存汇总" :visible.sync="inventorySummaryDialog">
        <div style="font-size: 16px">
            <el-form label-position="right" label-width="80px" class="EL-Form">
              <el-col :lg="7" :xl="7">
                <el-form-item label="工厂编号" class="EL-Form-Item">
                  <el-select multiple collapse-tags v-model="fcCodeList" filterable clearable="clearable">
                    <el-option v-for="item in factorys" :key="item.fcCode" :value="item.fcCode" :label="item.fcCode">{{ item.fcCode }}</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="7" :xl="7">
                    <el-form-item label="库位编号" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="lcCodeList" filterable clearable="clearable">
                          <el-option v-for="item in lcCodes" :key="item.lcCode" :value="item.lcCode" :label="item.lcCodeName">{{ item.lcCodeName }}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="7" :xl="7">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="inventorySummarySearch.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>

                 <el-col :lg="3" :xl="3">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getInventorySummary">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetInventorySummary">重置</el-button>
                    </el-form-item>
                </el-col>

                <el-col :lg="7" :xl="7">
                    <el-form-item label="批次号" class="EL-Form-Item">
                        <el-input v-model="inventorySummarySearch.batchNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>

               
                <el-col :lg="7" :xl="7">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="inventorySummarySearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions2"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="7" :xl="7">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="inventorySummarySearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions1"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="3" :xl="3">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button :loading="downloadLoading1" class="btn-t-edit" type="primary" @click="downLoadFileExport">导出EXCEL</el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <h-table :headerCellStyle="inventorySummaryData.headerCellStyle" :style="$popups.harvestRecordStyle(0.65)" @pageChange="getInventorySummary" :data="inventorySummaryData.data" pagination :nowPage.sync="inventorySummaryData.nowPage" :pageSize.sync="inventorySummaryData.pageSize" :total.sync="inventorySummaryData.total" @selectionChange="selectInvnentory">
                <!-- <el-table-column type="selection" align="center"> </el-table-column> -->
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="总数量" prop="matQuan" align="center">
                </el-table-column>
            </h-table>
        </div>
        <span slot="footer" class="dialog-footer footer-bottom">
            <!-- <el-button @click="closeProductPullDialog()" class="btn-t-info">关 闭</el-button> -->
            <!-- <el-button class="btn-t-edit" @click="openAddressDialog()">确 定</el-button> -->
        </span>
    </el-dialog>
  </div>
</template>

<script>
import vPrint from "syl-vue-printer";
import moment from "moment";
export default {
  name: "WhInventory",
  components: {
    vPrint,
  },
  data() {
    return {
      printData: [], //打印数据
      print: false,
      printShow: false,
      PrintBarcodeByDia: false,
      printObj: {
        id: "demo",
        popTitle: "",
      },
      printTime: moment(new Date()).format("yyyy-MM-DD"),

      factoryList: [],
      warehouseList: [],
      mainData: {
        data: [],
        nowPage: 1,
        pageSize: 50,
        total: 0,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },

      inventorySummaryData:{
        data: [],
        nowPage: 1,
        pageSize: 20,
        total: 0,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },

      //库存汇总选中的工厂
      fcCodeList: [],
      //库存汇总的所有工厂选择
      factorys: [],
      selectInvnentoryList:[],
      inventorySummaryDialog:false,
      lcCodes:[
        {'lcCodeName':'C00X','lcCode':'C00'},
        {'lcCodeName':'CE000','lcCode':'CE000'},
        {'lcCodeName':'30X','lcCode':'30'},
        {'lcCodeName':'PS001','lcCode':'PS001'},
        {'lcCodeName':'RET','lcCode':'RET'},
        {'lcCodeName':'WIP','lcCode':'WIP'},
        {'lcCodeName':'QC','lcCode':'QC'},
      ],
      lcCodeList:[],

      // 筛选条件
      mainSearch: {
        fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
        whCode: "", //	通道编号
        lcCode: "", //	库位编号
        lcType: "",
        matCode: "", //	物料编号
        matName: "", //	物料描述
        batchNo: "", //	批次号
        wiStatus: "", //	库存状态 normal
        boxBarcode: "", //	箱号
        orderCode: "", //  订单编号
        matSpecs: "", //  规值
        date: [],
        height: "", //第几层
      },

      downloadLoading1:false,

      inventorySummarySearch:{
        fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
        whCode: "", //	通道编号
        lcCode: "", //	库位编号
        matCode: "", //	物料编号
        batchNo: "", //	批次号
        date: [],
      },
      //全选
      checkList: [],
      selectAllPrintList: [],
      //下载中
      downloadLoading: false,
      //库区
      dictDataList: [],
      //选中的库区
      chooseDictDataList: [],
      //选中的工厂
      selectedFcList: [],
      //选中的通道
      whCodeList: [],
      // 输入框延时加载
      isSetTimeout: null,
      //箱数
      boxCount: 0,
      //总数量
      sumCount: 0,
      //库存编辑
      upDataShow: false,
      upDataObj: {},
      addDataShow: false,
      addDataObj: {
        matQuan: 0,
      },
      addDataList: [],
      PrintBarcodeByObj: {},
      materialData:[],
      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      newBoxBarcode:"",
      //校验
      ruleUp: {
        whCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        lcCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        matCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        prodCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        batchNo: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        matQuan: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        count: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        
        matCreateTime: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        checkResult: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    mainSearch: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.mainData.nowPage = 1;
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
    chooseDictDataList: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
    whCodeList: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
    selectedFcList: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },

  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[0]) {
            return time.getTime() < new Date(_this.mainSearch.date[0]);
          }
        },
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[1]) {
            return time.getTime() > new Date(_this.mainSearch.date[1]);
          }
        },
      };
    },
    pickerOptions1() {
        let _this = this
        return {
            disabledDate(time) {
                if (_this.inventorySummarySearch.date[0]) {
                    return time.getTime() < new Date(_this.inventorySummarySearch.date[0]);
                }
            }
        }
    },
    pickerOptions2() {
        let _this = this
        return {
            disabledDate(time) {
                if (_this.inventorySummarySearch.date[1]) {
                    return time.getTime() > new Date(_this.inventorySummarySearch.date[1]);
                }
            }
        }
    },
  },

  activated() {
    this.getWarehouse();
    this.getFactory();
    this.getDictData();
    this.getTableData();
    this.getAuxiMaterialData();
  },
  methods: {
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getTableData();
      }, 1000);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (column.property == "matQuan" ||
            column.property == "matDistrQuan" ||
            column.property == "matAvaliableQuan")
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });

      return sums;
    },
    /**
     *
     */
    getTableData() {
      clearTimeout(this.isSetTimeout);
      var mainSearchLcType = "";
      var whCode = "";
      var fcCode = "";
      this.chooseDictDataList.forEach((item) => {
        mainSearchLcType += item + ",";
      });
      this.whCodeList.forEach((item) => {
        whCode += item + ",";
      });
      this.selectedFcList.forEach((item) => {
        fcCode += item + ",";
      });
      if (fcCode == null || fcCode == "") {
        fcCode = localStorage.getItem("fcCode");
      } else {
        // 去掉后面的逗号
        fcCode = fcCode.substring(0, fcCode.length - 1);
      }

      this.$http
        .request({
          url: "/api/order/getFactoryAndCacheStockList",
          method: "GET",
          params: {
            pageNum: this.mainData.nowPage, //	页号
            pageSize: this.mainData.pageSize, //	页大小
            // 一厂和二厂展示所有库存，外厂只展示自己的库存
            fcCode: fcCode || null, // 工厂编号
            whCode: whCode || null, //	通道编号
            lcCode: this.mainSearch.lcCode || null,
            //lcType: this.mainSearch.lcType || null,
            lcType: mainSearchLcType || null,
            matCode: this.mainSearch.matCode || null, //	物料编号
            matName: this.mainSearch.matName || null, //	物料描述
            batchNo: this.mainSearch.batchNo || null, //	批次号
            wiStatus: this.mainSearch.wiStatus || null, //	库存状态
            boxBarcode: this.mainSearch.boxBarcode || null, //	箱号
            opCode: this.mainSearch.orderCode || null, //  订单编号
            matSpecs: this.mainSearch.matSpecs || null, //  规值
            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
            height: this.mainSearch.height || null,
            commonFlag: true, //查询公共库存的库存，不分工厂
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.mainData.data = res.data.list;
            this.mainData.total = res.data.total;
          } else {
            this.$message.error("错误");
          }
        });
    },
    getInventorySummary(){
      var fcCode = "";
      var lcCode = "";
      this.fcCodeList.forEach((item) => {
        fcCode += item + ",";
      });
      this.lcCodeList.forEach((item) => {
        lcCode += item + ",";
      });
      if (fcCode == null || fcCode == "") {
        fcCode = localStorage.getItem("fcCode");
      } else {
        // 去掉后面的逗号
        fcCode = fcCode.substring(0, fcCode.length - 1);
      }

      this.$http
        .request({
          url: "/api/order/getInventorySummary",
          method: "GET",
          params: {
            pageNum: this.inventorySummaryData.nowPage, //	页号
            pageSize: this.inventorySummaryData.pageSize, //	页大小
            // 一厂和二厂展示所有库存，外厂只展示自己的库存
            fcCode: fcCode || null, // 工厂编号
            lcCode:lcCode || null,
            whCode: this.inventorySummarySearch.whCode || null,  //	通道编号
            matCode: this.inventorySummarySearch.matCode || null, //	物料编号
            batchNo: this.inventorySummarySearch.batchNo || null, //	批次号
            beginTime: this.inventorySummarySearch.date ? this.inventorySummarySearch.date[0] : null,
            endTime: this.inventorySummarySearch.date ? this.inventorySummarySearch.date[1] : null,
            commonFlag: true, //查询公共库存的库存，不分工厂
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.inventorySummaryData.data = res.data.list;
            this.inventorySummaryData.total = res.data.total;
          } else {
            this.$message.error("错误");
          }
        });
    },
    //获取新箱号
    getNewBoxBarcode() {
            var type="BX";
            
            if (this.PrintBarcodeByObj.boxBarcode == null) {
              this.$http
                .request({
                    url: "/api/boxPrint/getNewBoxBarcode",
                    method: "GET",
                    params:{
                      type:type
                    }
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.PrintBarcodeByObj.boxBarcode = resp.data;
                        this.PrintBarcodeByDia = true;
                    }
                })
                .catch((error) => {
                    // this.loading--;
                });
            } else {
              this.PrintBarcodeByDia = true;
            }
        },
 //获取数据
 getAuxiMaterialData() {
            // this.loading++
          var paramsObj = {
            pageSize: 99999,
            pageNum: 1,
          }
            this.$http
                .request({
                    url: "/api/material/getMaterialAll",
                    method: "GET",
                    params: paramsObj,
                })
                .then((resp) => {
                    // this.loading--
                    if (resp.status == 100) {
                        // console.log(resp.data.list.length);
                        this.materialData = resp.data.list || [];
                        this.tableTotal = resp.data.total;
                    }
                })
                .catch((error) => {
                    // this.loading--;
                });
        },
    //获取库区
    getDictData() {
      this.$http
        .request({
          url: "/api/dictData/getDictData",
          method: "GET",
          showLoading: true,
          params: {
            ddCode: "LATYPE",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.dictDataList = resp.data.list || [];
          }
        })
        .catch((error) => {});
    },

    pdfPrint() {
      if (this.selectAllPrintList.length == 0) {
        this.$message({
          message: "请选择库存记录！",
          type: "warning",
        });
        return;
      }
      this.selectAllPrintList.forEach((item) => {
        this.boxCount += 1;
        this.sumCount += item.matQuan;
      });
      this.printShow = true;
      this.printData = this.selectAllPrintList;
    },

    /**
     * 全选
     */
    selectAllPrintLists(val) {
      this.selectAllPrintList = val;
    },

    /**
     * 库存汇总全选
     */
    selectInvnentory(val) {
      this.selectInvnentoryList = val;
    },

    //禁选
    checkboxSelect(row, rowIndex) {
      if (row.wiStatus == "NORMAL") {
        return true; // 不禁用
      } else {
        return false; // 禁用
      }
    },

    /**
     * 重置
     */
    reset() {
      this.mainSearch = {
        fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
        whCode: "", //	通道编号
        lcCode: "", //	库位编号
        lcType: "",
        matCode: "", //	物料编号
        matName: "", //	物料描述
        batchNo: "", //	批次号
        wiStatus: "", //	库存状态 normal
        boxBarcode: "", //	箱号
        orderCode: "", //  订单编号
        matSpecs: "", //  规值
        date: [],
        height: "", //第几层
      };
      this.chooseDictDataList = []; //选中的库区
    },

    resetInventorySummary(){
      this.inventorySummarySearch = {
        fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
        whCode: "", //	通道编号
        lcCode: "", //	库位编号
        matCode: "", //	物料编号
        batchNo: "", //	批次号
        date: [],
      }
    },

    /**
     * 通道列表
     */
    getWarehouse() {
      this.$http
        .request({
          url: "/api/checkTask/getWarehouse",
          method: "GET",
          params: {
            fcCode: this.mainSearch.fcCode || null,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.warehouseList = res.data;
          } else {
            this.$message.error("错误");
          }
        });
    },

    getFactory() {
      this.selectedFcList[0] = localStorage.getItem("fcCode");

      let fcCodes = null;
      let userFcCode = localStorage.getItem("fcCode") || null;

      if (userFcCode == "YL" || userFcCode == "SY") {
        fcCodes = userFcCode;
      }

      this.$http
        .request({
          url: "/api/factory/getFactoryAll",
          method: "GET",
          params: {
            fcCode: fcCodes,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.factoryList = res.data.list || [];
          } else {
            this.$message.error("错误");
          }
        });
    },

    //库存汇总
    getFactoryList() {
      this.fcCodeList[0] = localStorage.getItem("fcCode");

      let fcCodes = null;
      let userFcCode = localStorage.getItem("fcCode") || null;

      if (userFcCode == "YL" || userFcCode == "SY") {
        fcCodes = userFcCode;
      }

      this.$http
        .request({
          url: "/api/factory/getFactoryAll",
          method: "GET",
          params: {
            fcCode: fcCodes,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.factorys = res.data.list || [];
          } else {
            this.$message.error("错误");
          }
        });
    },

    /**
     * 盘点——查询条件
     */
    insertStockCheckTaskByParam() {
      this.$confirm("是否确认将所有的查询结果进行盘点?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .request({
              url: "/api/checkTask/insertStockCheckTaskByParam",
              method: "POST",
              showLoading: true,
              params: {
                fcCode: this.mainSearch.fcCode || null, //	工厂编号
                whCode: this.mainSearch.whCode || null, //	通道编号
                matCode: this.mainSearch.matCode || null, //	物料编号
                matName: this.mainSearch.matName || null, //	物料描述
                batchNo: this.mainSearch.batchNo || null, //	批次号
                wiStatus: this.mainSearch.wiStatus || null, //	库存状态
                boxBarcode: this.mainSearch.boxBarcode || null, //	箱号
                beginTime: this.mainSearch.date
                  ? this.mainSearch.date[0]
                  : null,
                endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: resp.message,
                  type: "error",
                });
              }
              this.getTableData();
            })
            .catch((error) => {
              this.$message({
                message: "操作失败:" + error.message,
                type: "warning",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    /**
     * 盘点——勾选
     */
    insertStockCheckTaskByList() {
      if (this.checkList.length == 0) {
        this.$message({
          message: "请勾选库存！",
          type: "warning",
        });
        return;
      }
      this.$confirm("是否确认将已选择的库存进行盘点?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .request({
              url: "/api/checkTask/insertStockCheckTaskByList",
              method: "POST",
              showLoading: true,
              data: this.checkList,
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: resp.message,
                  type: "error",
                });
              }
              this.getTableData();
            })
            .catch((error) => {
              this.$message({
                message: "操作失败:" + error.message,
                type: "warning",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    PrintBarcodeBy() {
      //无码时添加打印限制
      if (this.lazyNext) {
        this.$message.error("请五秒后再打印！");
        return;
      } else {
          var produceTime = moment(this.PrintBarcodeByObj.date).format("YYYYMMDD");
          //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
          // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
          //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
          //     "/" + produceTime + "/" + item.boxHeight + "/";

          //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
          var qrCode =
          this.PrintBarcodeByObj.boxBarcode +
            "," +
            this.PrintBarcodeByObj.batchNo +
            "," +
            this.PrintBarcodeByObj.whCode +
            "," +
            this.PrintBarcodeByObj.prodCode +
            "," +
            this.PrintBarcodeByObj.count +
            "," +
            this.PrintBarcodeByObj.matSpecs +
            "," +
            this.PrintBarcodeByObj.batchNo +
            "," +
            produceTime +
            ",,,";

          if (this.PrintBarcodeByObj.matSpecs == undefined) {
            this.PrintBarcodeByObj.matSpecs = "";
          }

          var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
          var barcodeData = {
            boxBarcode: this.PrintBarcodeByObj.boxBarcode,
            prodCode: this.PrintBarcodeByObj.prodCode,
            prodName: this.PrintBarcodeByObj.prodName,
            batchNo: this.PrintBarcodeByObj.batchNo,
            count: this.PrintBarcodeByObj.count,
            checkPerson: "",
            date: produceTime,
            poCode: this.PrintBarcodeByObj.batchNo,
            matSpecs: this.PrintBarcodeByObj.matSpecs,
            whCode: this.PrintBarcodeByObj.whCode,
            qrCode: qrCode,
            supply: this.PrintBarcodeByObj.supply,
            printTime: printTime,
            isSta: false,
            printTwo: false,
            location: this.PrintBarcodeByObj.location,
          };
          this.$printer.printWMSBarcode(barcodeData);

        this.lazyNext = setTimeout(() => {
          this.lazyNext = null;
        }, 5000);
      }
    },
    //标签打印
    rePrintBarcode() {
      if (this.selectAllPrintList.length == 0) {
        this.$message({
          message: "请勾选打印单！",
          type: "warning",
        });
        return;
      }
      //无码时添加打印限制
      if (this.lazyNext) {
        this.$message.error("请五秒后再打印！");
        return;
      } else {
        this.selectAllPrintList.forEach((item) => {
          var produceTime = moment(item.matCreateTime).format("YYYYMMDD");
          //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
          // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
          //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
          //     "/" + produceTime + "/" + item.boxHeight + "/";

          //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
          var qrCode =
            item.boxBarcode +
            "," +
            item.orderCode +
            "," +
            item.whCode +
            "," +
            item.matCode +
            "," +
            item.matQuan +
            "," +
            item.matSpecs +
            "," +
            item.batchNo +
            "," +
            produceTime +
            "," +
            item.boxHeight +
            ",,,";

          if (item.matSpecs == undefined) {
            item.matSpecs = "";
          }

          var person = localStorage.getItem("user");
          if (person != undefined && person != "") {
            person = item.consignee;
          }

          var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
          var barcodeData = {
            boxBarcode: item.boxBarcode,
            prodCode: item.matCode,
            prodName: item.matName,
            batchNo: item.batchNo,
            count: item.matQuan,
            checkPerson: person,
            date: produceTime,
            poCode: item.orderCode,
            matSpecs: item.matSpecs,
            whCode: item.whCode,
            boxHeight: item.boxHeight,
            qrCode: qrCode,
            supply: "",
            printTime: printTime,
            isSta: false,
            printTwo: false,
            location: item.lcCode,
          };
          this.$printer.printWMSBarcode(barcodeData);
        });

        this.lazyNext = setTimeout(() => {
          this.lazyNext = null;
        }, 5000);
      }
    },

    downLoadFileExport(){
      this.downloadLoading1 = true;
      var lcCode = "";
      var fcCode = "";
      this.lcCodeList.forEach((item) => {
        lcCode += item + ",";
      });
      this.fcCodeList.forEach((item) => {
        fcCode += item + ",";
      });
      var paramsObj = {
        fcCode: fcCode || null, // 工厂编号
        lcCode:lcCode || null,
        whCode: this.inventorySummarySearch.whCode || null,  //	通道编号
        matCode: this.inventorySummarySearch.matCode || null, //	物料编号
        batchNo: this.inventorySummarySearch.batchNo || null, //	批次号
        beginTime: this.inventorySummarySearch.date ? this.inventorySummarySearch.date[0] : null,
        endTime: this.inventorySummarySearch.date ? this.inventorySummarySearch.date[1] : null,
        commonFlag: true, //查询公共库存的库存，不分工厂
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/order/getInventorySummary",
          method: "GET",
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad1(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },

        downLoad1(list) {
          list.forEach(function (c) {
            
          });
          import("@/libs/Export2Excel").then((excel) => {
            const tHeader = [
              "物料编号",
              "物料总数量",
            ];
            const filterVal = [
              "matCode",
              "matQuan",
            ];
            const data = this.formatJson1(filterVal, list);
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: "库存汇总单",
            });
            this.logContent = "导出";
            this.logRemarks = "wh_inventory：导出库存汇总";
            this.systemLog();
            this.downloadLoading1 = false;
          });
        },
        formatJson1(filterVal, jsonData) {
          return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var fcCode = "";
      var whCode = "";
      var mainSearchLcType = "";
      this.selectedFcList.forEach((item) => {
        fcCode += item + ",";
      });
      this.chooseDictDataList.forEach((item) => {
        mainSearchLcType += item + ",";
      });
      this.whCodeList.forEach((item) => {
        whCode += item + ",";
      });
      if (fcCode == null || fcCode == "") {
        fcCode = localStorage.getItem("fcCode");
      } else {
        // 去掉后面的逗号
        fcCode = fcCode.substring(0, fcCode.length - 1);
      }
      var paramsObj = {
        // 一厂和二厂展示所有库存，外厂只展示自己的库存
        // fcCode:
        //   this.mainSearch.fcCode == "ATC1" || this.mainSearch.fcCode == "ATC2"
        //     ? null
        //     : this.mainSearch.fcCode || null, // 工厂编号
        fcCode: fcCode || null, // 工厂编号
        whCode: whCode || null, // 通道编号
        lcCode: this.mainSearch.lcCode || null,
        lcType: mainSearchLcType || null,
        matCode: this.mainSearch.matCode || null, // 物料编号
        matName: this.mainSearch.matName || null, // 物料描述
        batchNo: this.mainSearch.batchNo || null, // 批次号
        wiStatus: this.mainSearch.wiStatus || null, // 库存状态
        boxBarcode: this.mainSearch.boxBarcode || null, // 箱号
        opCode: this.mainSearch.orderCode || null, //  订单编号
        matSpecs: this.mainSearch.matSpecs || null, //规值
        beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
        endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
        height: this.mainSearch.height || null,
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/order/getFactoryAndCacheStockList",
          method: "GET",
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    downLoad(list) {
      list.forEach(function (c) {
        if (c.wiStatus == "NORMAL") {
          c["wiStatus"] = "正常";
        } else if (c.wiStatus == "FREEZE") {
          c["wiStatus"] = "拣配中";
          // } else if (c.wiStatus == 'OVERTIME') {
          //     c['wiStatus'] = '过期'
          // } else if (c.wiStatus == 'DELETE') {
          //     c['wiStatus'] = '作废'
        } else if (c.wiStatus == "AGFREEZE") {
          c["wiStatus"] = "冻结";
        }

        if (c.checkResult == "10") {
          c["checkResult"] = "待检";
        } else if (c.checkResult == "20") {
          c["checkResult"] = "合格";
        } else if (c.checkResult == "30") {
          c["checkResult"] = "不合格";
        }

        if (c.saleFlag) {
          c["saleFlag"] = "是";
        } else {
          c["saleFlag"] = "否";
        }
      });
      import("@/libs/Export2Excel").then((excel) => {
        const tHeader = [
          "工厂",
          "通道编号",
          "物料编号",
          "物料描述",
          "物料总数量",
          "已分配数量",
          "可用数量",
          "物料批次",
          "库位",
          "包装箱号",
          "订单编号",
          "规值",
          "物料状态",
          "收货人",
          "入库时间",
          "质检状态",
          "是否寄售",
          "供应商",
          "供应商名称",
          "备注",
        ];
        const filterVal = [
          "fcCode",
          "whCode",
          "matCode",
          "matName",
          "matQuan",
          "matDistrQuan",
          "matAvaliableQuan",
          "batchNo",
          "lcCode",
          "boxBarcode",
          "orderCode",
          "matSpecs",
          "wiStatus",
          "consignee",
          "matCreateTime",
          "checkResult",
          "saleFlag",
          "verdorCode",
          "svName",
          "remark",
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "库存记录单",
        });
        this.logContent = "导出";
        this.logRemarks = "wh_inventory：导出库存记录";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    // 新增库存
    addWhInventory() {
      // 默认存放到DM001虚拟库位上
      this.addDataObj.lcCode = 'CE000';
      this.addDataShow = true;
    },

    // 新增库存
    openInventorySummaryDialog() {
      this.getFactoryList();
      this.lcCodeList.push("C00");
      this.lcCodeList.push("CE000");
      this.lcCodeList.push("30");
      this.lcCodeList.push("QC");
      this.getInventorySummary();
      this.inventorySummaryDialog = true;
    },

    saveWhInventory() {
      if (this.submitForm("addDataObj")) {
        this.addDataObj.fcCode = localStorage.getItem("fcCode") || "";

        this.addDataList[0] = this.addDataObj;

        this.$http
          .request({
            url: "/api/inventory/temporaryUse/save",
            method: "POST",
            showLoading: true,
            data: this.addDataList,
          })
          .then((resp) => {
            if (resp.status == 100) {
              this.$notify({
                title: "成功",
                message: "保存成功！",
                type: "success",
              });
            } else {
              this.$notify.error({
                title: "失败",
                message: resp.message,
              });
            }

            this.addDataObj.matCode = null;
            this.addDataObj.matQuan = 0;
            this.addDataShow = false;
          });
      }
    },

    //修改库存
    upWhInventory() {
      if (this.selectAllPrintList.length == 0) {
        this.$message({
          message: "请选择库存记录！",
          type: "warning",
        });
        return;
      }
      if (this.selectAllPrintList.length > 1) {
        this.$message({
          message: "只能选择单条库存记录！",
          type: "warning",
        });
        return;
      }
      this.upDataShow = true;
      this.upDataObj = this.deepCopy(this.selectAllPrintList[0]);
    },

    updateWhInventory() {
      if (this.submitForm("upDataObj")) {
        this.$http
          .request({
            url: "/api/inventory/updateInventoryData",
            method: "POST",
            showLoading: true,

            data: this.upDataObj,
          })
          .then((resp) => {
            if (resp.status == 100) {
              this.$notify({
                title: "成功",
                message: "编辑成功！",
                type: "success",
              });
              this.logRemarks =
                "WhInventory：编辑成功" + JSON.stringify(this.upDataObj);
            } else {
              this.$notify.error({
                title: "失败",
                message: "编辑失败",
              });
              this.logRemarks =
                "WhInventory：编辑失败" + JSON.stringify(this.upDataObj);
            }
            this.upDataShow = false;
            this.saveSearch();
            this.systemLog();
          });
      }
    },
    //表单验证
    submitForm(formName) {
      let r = Boolean;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          r = true;
        } else {
          r = false;
        }
      });
      return r;
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "库存记录",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          showLoading: true,
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped>
.div {
  width: 95%;
  height: 100%;
  /* border: 1px solid black; */
  /* margin-top: 107px; */
  margin-left: 30px;
  margin-bottom: 100px;
  text-align: center;
}

.div table th {
  width: 100px;
  height: 30px;
  border: 1px solid black;
  background: rgb(201, 197, 197);
  color: rgb(14, 13, 13);
}

.div table td {
  width: 100px;
  height: 30px;
  /* border: 1px solid black; */
  color: rgb(14, 13, 13);
}

.div1 {
  /* width: 300px; */
  height: 40px;
  /* border: 1px solid black; */
  text-align: left;
  color: rgb(14, 13, 13);
  font-weight: bold;
  margin-left: 50px;
}
</style>